import sharedCss from '../shared/shared.styles';

export default (theme: Object) => ({
  screenContainer: {
    ...sharedCss.screenContainer,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  screenTitle: {
    ...sharedCss.screenTitle(theme),
    fontSize: 16,
    textAlign: 'center',
  },
  selectionButton: {
    width: '100%',
    marginBottom: '20px',
  },
});
